var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dots Vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.5 11.875C8.12132 11.875 8.625 12.3787 8.625 13C8.625 13.6213 8.12132 14.125 7.5 14.125C6.87868 14.125 6.375 13.6213 6.375 13C6.375 12.3787 6.87868 11.875 7.5 11.875ZM7.5 6.875C8.12132 6.875 8.625 7.37868 8.625 8C8.625 8.62132 8.12132 9.125 7.5 9.125C6.87868 9.125 6.375 8.62132 6.375 8C6.375 7.37868 6.87868 6.875 7.5 6.875ZM7.5 1.875C8.12132 1.875 8.625 2.37868 8.625 3C8.625 3.62132 8.12132 4.125 7.5 4.125C6.87868 4.125 6.375 3.62132 6.375 3C6.375 2.37868 6.87868 1.875 7.5 1.875Z",
    fill: "#C7C7C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotve);
export default __webpack_public_path__ + "static/media/dotve.bee3da1220cf9a790409c4ef9b6402a1.svg";
export { ForwardRef as ReactComponent };